export default "__VITE_ASSET__DC0LQTCb__"